export default {"src":"https://static.eleduck.com/_next/static/media/404.96748162.gif","height":240,"width":240,"blurWidth":0,"blurHeight":0};